import React, { useState, useEffect, useRef, useCallback } from "react";
import {
  Avatar,
  Box,
  Button,
  Dropdown,
  DropdownBody,
  DropdownItem,
  getColor,
  Icons,
  Modal,
  Tooltip,
  Typography,
  useToast,
} from "fds";
import "./index.scss";
import utilsCommon from "../../../shared/utils/common";
import WorkgroupAddModal from "../../../components/WorkgroupAddModal";
import { getUserInfoFromLocalStorage } from "../../../shared/utils/auth";
import { LoginDto } from "../../../types/auth";
import useWorkgroupStore from "../../../redux/dispatcher/useWorkgroupStore";
import {
  CalendarCount,
  Member,
  WorkgroupHomeDashboard,
} from "../../../types/workgroup";
import useChatStore from "../../../redux/dispatcher/useChatStore";
import { useNavigate } from "react-router-dom";
import "react-day-picker/style.css";
import dayjs from "dayjs";
import WorkgroupManagerIcon from "../../../components/WorkgroupManagerIcon";
import {
  handleDocDownload,
  handleDocPreview,
  startZoomMeeting,
} from "../../../shared/utils/api";
import ShareMeetingLinkModal from "../../../components/More/ShareMeetingLinkModal";
import useDocumentStore from "../../../redux/dispatcher/useDocumentStore";
import { useTranslation } from "react-i18next";
import { DayPicker } from "react-day-picker";
import CompressWorkgroupLog from "../WorkgroupLog/CompressWorkgroupLog";
import { LogItem } from "../../../types/files";
import { meetingDTO } from "../../../types/meeting";
import LogSettingButton from "../WorkgroupLog/LogSettingButton";
import classNames from "classnames";
import MeetingDetailModal from "../../../components/MeetingDetailModal";
import FileUploadModal from "../WorkgroupFile/Modal/FileUploadModal";
import i18n from "fds/src/locales/i18n";
import useLogStore from "../../../redux/dispatcher/useLogStore";
import AppRegisterModal from "../../../components/AppRegisterModal";
import useAppStore from "../../../redux/dispatcher/useAppStore";
import useMeetingStore from "../../../redux/dispatcher/useMeetingStore";
import { nanoid } from "@reduxjs/toolkit";
const direction = document.documentElement.dir; // 'ltr' 또는 'rtl'

export const months = {
  ko: [
    "1월",
    "2월",
    "3월",
    "4월",
    "5월",
    "6월",
    "7월",
    "8월",
    "9월",
    "10월",
    "11월",
    "12월",
  ],
  en: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ],
  ar: [
    "يناير", // January
    "فبراير", // February
    "مارس", // March
    "أبريل", // April
    "مايو", // May
    "يونيو", // June
    "يوليو", // July
    "أغسطس", // August
    "سبتمبر", // September
    "أكتوبر", // October
    "نوفمبر", // November
    "ديسمبر", // December
  ],
};
export const langCalendar =
  i18n.language === "ko" ? "ko" : i18n.language === "ar" ? "ar" : "en";
const WorkgroupHome = ({ workgroupId }: { workgroupId: string }) => {
  const WEEKDAYS_KO = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const user = getUserInfoFromLocalStorage() as string | "";
  const loginDto: LoginDto = JSON.parse(user);
  const navigate = useNavigate();
  const toast = useToast();
  const { t } = useTranslation();

  const inputRef = useRef<HTMLTableRowElement>(null);
  const {
    workgroupState,
    getWorkgroupHomeDashboard,
    getWorkgroupCalendarCount,
    getWorkgroupCalendarDetail,
    getWorkgroupDetail,
  } = useWorkgroupStore();
  const { appState } = useAppStore();
  const { chatRecent } = useChatStore();
  const { getContentDownload } = useDocumentStore();
  const { getMeetingDetail } = useMeetingStore();
  const { logState } = useLogStore();

  const [openExtraModal, changeOpenExtraModal] = useState("CLOSE");
  const [buttonClick, changeButtonClick] = useState(0);
  const [openMemberTab, toggleOpenMemberTab] = useState(true);
  const [selected, setSelected] = useState<Date | undefined>();
  const [size, setSize] = useState({ width: 0, height: 0 });
  const [dashboard, changeDashBoardInfo] = useState<WorkgroupHomeDashboard>({
    readRequestCount: 0,
    todayUpdateFileCount: 0,
    todayMeeringCount: 0,
    unreadChat: 0,
  });
  const [openMeetingModal, changeMeetingOpenModal] = useState<
    meetingDTO | undefined
  >();
  const [settingButtonInfo, setSettingInfo] = useState<{
    x: number;
    y: number;
    logId: string;
    log?: LogItem;
    meetingInfo?: meetingDTO;
  }>({
    x: 0,
    y: 0,
    logId: "",
    log: undefined,
    meetingInfo: undefined,
  });
  const [workgroupSettingInfo, setWorkgroupSettingInfo] = useState<{
    x: number;
    y: number;
    item?: any;
    id: number;
  }>({
    x: 0,
    y: 0,
    id: -1,
  });
  useEffect(() => {
    getWorkgroupCalendarDetail({
      workgroupId,
      date: utilsCommon.getStartDay(selected ?? new Date()).valueOf(),
    });
  }, [workgroupId, selected]);
  useEffect(() => {
    if (utilsCommon.getChatAvailibility() === "true") {
      chatRecent(workgroupId).then((resp: any) =>
        changeDashBoardInfo({
          ...workgroupState.workgroupHomeDashboard,
          unreadChat: resp.payload.unreadCount,
        })
      );
    } else changeDashBoardInfo({ ...workgroupState.workgroupHomeDashboard });
  }, [workgroupState.workgroupHomeDashboard]);
  useEffect(() => {
    setSelected(undefined);
    getWorkgroupDetail({ workgroupId });
    getWorkgroupHomeDashboard(workgroupId);
    handleMonthChange(new Date());
  }, [workgroupId]);
  const handleClickOutside = useCallback((e: MouseEvent) => {
    if (inputRef.current && !(inputRef.current! as any).contains(e.target)) {
      if (openExtraModal.startsWith("REGISTER_ZOOM")) return;
      handleInitSettingInfo();
      document.removeEventListener("click", handleClickOutside, true);
    }
  }, []);
  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  });
  const handleInitSettingInfo = () => {
    setWorkgroupSettingInfo({
      x: 0,
      y: 0,
      id: -1,
    });
  };
  const CustomChevron = (props: any) => {
    return props.orientation === "right" ? (
      <Icons variant={"line"} label={"chevron"} direction="right" />
    ) : props.orientation === "left" ? (
      <Icons variant={"line"} label={"chevron"} direction="left" />
    ) : (
      <Icons variant={"line"} label={"chevron"} direction="down" />
    );
  };
  const colorMap = {
    meetings: "#6D29F6",
    readRequest: "#0095FF",
    sign: "#FAA131",
  };
  const handleMonthChange = (newMonth: Date) => {
    const startDate = dayjs(newMonth)
      .subtract(1, "month")
      .set("date", 15)
      .valueOf();
    const endDate = dayjs(newMonth).add(1, "month").set("date", 15).valueOf();
    const currDate = dayjs(newMonth).set("date", 15).valueOf();
    getWorkgroupCalendarCount({
      workgroupId: workgroupId,
      startDate: startDate,
      endDate: endDate,
      date: currDate,
      offset: -new Date().getTimezoneOffset() / 60,
    });
  };
  const renderWorkgroupCalendar = () => {
    return (
      <DayPicker
        captionLayout="dropdown"
        mode="single"
        className={classNames(langCalendar, "workgroupCalendar")}
        animate
        key={workgroupId}
        showOutsideDays
        selected={selected}
        onSelect={setSelected}
        numerals="latn"
        dir={direction}
        onMonthChange={handleMonthChange}
        disabled={{
          before: new Date(workgroupState.workgroupDetail?.workgroup?.logDate),
        }}
        components={{
          Chevron: CustomChevron,
          YearsDropdown: (props) => {
            return (
              <Dropdown
                placeholder=" "
                value={props.value + (i18n.language.includes("ko") ? "년" : "")}
                showValue
                dropdownMaxHeight={240}
                btnStyle="link"
                buttonClick={buttonClick}
              >
                {Array(
                  dayjs(workgroupState.workgrupDetail?.workgroup?.logDate).diff(
                    dayjs().valueOf(),
                    "year"
                  ) + 1
                )
                  .fill(0)
                  .map((item, index) => (
                    <DropdownItem
                      classes="rdp-month_caption--dropdown"
                      onClick={(e) => {
                        props.onChange &&
                          props.onChange({
                            ...e,
                            target: {
                              ...e.target,
                              value: dayjs().get("year") - index,
                            },
                          });
                        changeButtonClick(buttonClick + 1);
                      }}
                      label={dayjs().get("year") - index}
                    />
                  ))}
              </Dropdown>
            );
          },
          MonthsDropdown: (props) => (
            <Dropdown
              placeholder=" "
              value={months[langCalendar][Number(props.value)]}
              showValue
              width={88}
              dropdownMaxHeight={240}
              btnStyle="link"
              buttonClick={buttonClick}
              classes="rdp-dropdowns rdp-month_caption--dropdown"
            >
              {months[langCalendar].map((item, index) => (
                <DropdownItem
                  onClick={(e) => {
                    props.onChange &&
                      props.onChange({
                        ...e,
                        target: {
                          ...e.target,
                          value: index,
                        },
                      });
                    changeButtonClick(buttonClick + 1);
                  }}
                  label={item}
                />
              ))}
            </Dropdown>
          ),
          Day: (props) => {
            let todayList = workgroupState.calendarCount?.filter(
              (item: CalendarCount) =>
                dayjs(parseInt(item.date)).format("YYYY-MM-DD") ===
                dayjs(props.day.date).format("YYYY-MM-DD")
            )[0]?.counts;
            const dots = [
              ...[todayList?.meetings ? colorMap.meetings : undefined],
              ...[todayList?.sign ? colorMap.sign : undefined],
              ...[todayList?.readRequest ? colorMap.readRequest : undefined],
            ];
            return (
              <td className={`${props.className}`} width={"52px"}>
                {props.children}
                <div
                  className="dot-container"
                  // style={{ left: "50%", transform: "translateX(-50%)" }}
                >
                  {Array.from(new Set(dots))
                    .filter((dot) => dot)
                    .sort(
                      (a: any, b: any) =>
                        ["#6D29F6", "#0095FF", "#FAA131"].indexOf(a) -
                        ["#6D29F6", "#0095FF", "#FAA131"].indexOf(b)
                    )
                    .map((color, idx) => (
                      <span
                        key={idx}
                        className="dot"
                        style={{ backgroundColor: color }}
                      />
                    ))}
                </div>
              </td>
            );
          },
        }}
        formatters={{
          formatWeekdayName: (date) => WEEKDAYS_KO[date.getDay()],
        }}
      />
    );
  };
  const handleClickCalendarItem = (item: any) => {
    if (!("meetingId" in item)) {
      handleDocPreview({
        permission: "view",
        workgroupId: workgroupId,
        syncId: item?.syncId,
        toast,
        t,
        revisionNo: 0,
        noNeedToast: true,
      }).then((resp) => {
        if (resp !== "SUCCESS") {
          handleDocDownload(
            item.syncId,
            getContentDownload,
            toast,
            t,
            "0",
            "",
            true
          );
        }
      });
    } else {
      changeMeetingOpenModal(item);
    }
  };
  const renderWorkgroupSelectItem = (item: any, index: number) => {
    const getItemProps = (item: any) => {
      const key = item.topic
        ? "meetings"
        : item.senderId
        ? "signs"
        : "readRequests";
      return {
        main:
          {
            meetings: t("common.meeting"),
            readRequests: t("home.myTasks.readRequst"),
            signs: t("file.comment"),
          }[key] || "",
        dotColor:
          {
            meetings: "#6D29F6",
            readRequests: "#0095FF",
            signs: "#FAA131",
          }[key] || "",
        title:
          {
            meetings: item?.topic ?? "",
            readRequests: item?.contentName ?? "",
            signs: item?.contentName ?? "",
          }[key] || "",
        body:
          {
            meetings:
              `${t("meeting.participants")}: ` +
              (item?.participantList
                ?.map((item: any) => item?.userName || item?.userId)
                .join(", ") ?? ""),
            readRequests:
              `${t("home.myTasks.requester")}: ` +
              (item.requestUserName ?? item.requestUser ?? ""),
            signs:
              `${t("workgroup.home.writer")}: ` +
              (item.senderName ?? item.senderId ?? ""),
          }[key] || "",
      };
    };
    const props = getItemProps(item);
    return (
      <Box classes={classNames("workgroupHome-calendar--item")}>
        <Box alignItems="center" style={{ position: "relative" }}>
          <Icons
            variant="fill"
            label="dot"
            stroke={props.dotColor}
            classes="authDot"
          />
          <Typography type="body3_rg" classes="mg ml-8">
            {props.main}
          </Typography>
          {(dayjs().valueOf() < dayjs(item.endTime).valueOf() ||
            !("meetingId" in item)) && (
            <Button
              btnStyle={"icon"}
              size="sm"
              classes="workgroupHome-calendar--more"
              onClick={(e) => {
                e.stopPropagation();
                setWorkgroupSettingInfo({
                  x: e.pageX - 240,
                  y: e.pageY - 61,
                  item: item,
                  id: index,
                });
              }}
              leadingIcon={
                <Icons
                  variant="line"
                  label="moreVertical"
                  stroke={getColor("COLOR_ICON_INTERACTIVE_TERTIARY")}
                />
              }
            />
          )}
        </Box>
        <Tooltip message={props.title}>
          <Typography
            type="subtitle2"
            ellipsis
            classes={classNames("mg mt-4 hover-text-underline")}
            onClick={() => handleClickCalendarItem(item)}
          >
            {props.title}
          </Typography>
        </Tooltip>
        <Tooltip message={props.body}>
          <Typography
            type="body4_rg"
            ellipsis
            classes="mg mt-4"
            exactColor={getColor("COLOR_AVATAR_COOL_GRAY_TEXT")}
          >
            {props.body}
          </Typography>
        </Tooltip>
      </Box>
    );
  };
  const renderWorkgroupSelectList = () => {
    const list = workgroupState.calendarDetail?.events;
    return (
      <Box direction="column">
        <Box height={28} alignItems="center">
          <Typography type="subtitle2">
            {utilsCommon.renderShortDateFormat(dayjs(selected).valueOf())}
          </Typography>
        </Box>
        <Box classes="mg mt-8 overflow-scroll" direction="column" height={250}>
          {list &&
          [...list?.meetings, ...list?.signs, ...list?.readRequests]?.length >
            0 ? (
            [...list?.meetings, ...list?.signs, ...list?.readRequests]?.map(
              (item, index) => renderWorkgroupSelectItem(item, index)
            )
          ) : (
            <Box
              direction="column"
              alignItems="center"
              justifyContent="center"
              height={"100%"}
            >
              <Box
                width={200}
                height={120}
                alignItems="center"
                justifyContent="center"
              >
                <img
                  src={require("../../../shared/images/pages/Workgroup/noCalendar.png")}
                  alt="noFilter"
                  width={130}
                  height={80}
                />
              </Box>
              <Typography
                exactColor={getColor("COLOR_TEXT_INFO")}
                type="body2_rg"
              >
                {t("workgroup.home.noScheduleToShow")}
              </Typography>
            </Box>
          )}
        </Box>
      </Box>
    );
  };
  const renderNameTag = (user?: Member, isManager?: boolean) => {
    return (
      <Box maxWidth={"100%"} minHeight={54} height={54} alignItems="center">
        <Avatar
          name={user?.userName}
          uniqueCode={utilsCommon.getUserColor(
            user?.userType,
            user?.status,
            user?.userName
          )}
          icon={user?.userName ? undefined : "user"}
          subLeftIcon={
            isManager ? (
              <WorkgroupManagerIcon
                style={{
                  position: "absolute",
                  bottom: "-5px",
                  insetInlineEnd: "-12px",
                }}
              />
            ) : undefined
          }
        />
        <Box
          direction="column"
          justifyContent="center"
          classes="mg ml-8"
          width={"calc(100% - 62px)"}
        >
          <Tooltip
            message={utilsCommon.getUserNameIdTag(
              user?.userId ?? "",
              user?.userName
            )}
          >
            <Typography type="body2_rg" ellipsis>
              {utilsCommon.getUserNameIdTag(user?.userId ?? "", user?.userName)}
            </Typography>
          </Tooltip>
          <Tooltip
            message={utilsCommon.getUserPositionNDept({
              positionName: user?.positionName,
              deptName: user?.deptName,
              companyName: user?.companyName,
              userType: user?.userType,
            })}
          >
            <Typography
              classes="mg mt-2"
              type="caption1_rg"
              exactColor={getColor("COLOR_TEXT_SECONDARY")}
              ellipsis
            >
              {utilsCommon.getUserPositionNDept({
                positionName: user?.positionName,
                deptName: user?.deptName,
                companyName: user?.companyName,
                userType: user?.userType,
              })}
            </Typography>
          </Tooltip>
        </Box>
      </Box>
    );
  };
  const renderMemberTab = () => {
    const managerId = workgroupState.workgroupDetail?.workgroup?.managerId;
    return (
      <Box direction="column" classes="mg ml-20 workgroupHome-members">
        <Typography
          type="body3_rg"
          exactColor={getColor("COLOR_TEXT_SECONDARY")}
        >
          {t("workgroup.managerShort")}
        </Typography>
        {renderNameTag(
          workgroupState.workgroupDetail?.workgroup?.members.filter(
            (item: Member) => managerId === item?.userId
          )[0],
          true
        )}
        {workgroupState.workgroupDetail?.workgroup?.members.filter(
          (item: Member) => managerId !== item?.userId && item.userType === 1
        ).length > 0 && (
          <Typography
            type="body3_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("common.internalUser")}
          </Typography>
        )}
        {workgroupState.workgroupDetail?.workgroup?.members
          .filter(
            (item: Member) => managerId !== item?.userId && item.userType === 1
          )
          .map((user: Member) => renderNameTag(user))}
        {workgroupState.workgroupDetail?.workgroup?.members.filter(
          (item: Member) =>
            managerId !== item?.userId &&
            item.userType === 2 &&
            item.status === 1
        ).length > 0 && (
          <Typography
            type="body3_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("common.externalUser")}
          </Typography>
        )}
        {workgroupState.workgroupDetail?.workgroup?.members
          .filter(
            (item: Member) =>
              managerId !== item?.userId &&
              item.userType === 2 &&
              item.status === 1
          )
          .map((user: Member) => renderNameTag(user))}
        {workgroupState.workgroupDetail?.workgroup?.members.filter(
          (item: Member) =>
            managerId !== item?.userId &&
            item.userType === 2 &&
            item.status !== 1
        ).length > 0 && (
          <Typography
            type="body3_rg"
            exactColor={getColor("COLOR_TEXT_SECONDARY")}
          >
            {t("common.noJoinUser")}
          </Typography>
        )}
        {workgroupState.workgroupDetail?.workgroup?.members
          .filter(
            (item: Member) =>
              managerId !== item?.userId &&
              item.userType === 2 &&
              item.status !== 1
          )
          .map((user: Member) => renderNameTag(user))}
      </Box>
    );
  };
  useEffect(() => {
    if (!inputRef.current) return;
    const observer = new ResizeObserver(() => {
      if (inputRef.current) {
        setSize({
          width: inputRef.current.offsetWidth,
          height: inputRef.current.offsetHeight,
        });
      }
    });
    observer.observe(inputRef.current);
    return () => observer.disconnect();
  }, []);
  const handleChooseEditMeetingStatus = (target_item: {
    meetingId: string;
    occurrenceId: string;
  }) => {
    if (target_item.occurrenceId === "NONE") {
      sessionStorage.setItem(
        "changeMeeting",
        `${target_item.meetingId}/${target_item.occurrenceId}`
      );
      navigate(
        `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting?subTab=CHANGE`
      );
    } else {
      changeOpenExtraModal(
        `CHANGE_MEETING@@${target_item.meetingId}/${target_item.occurrenceId}`
      );
    }
  };
  const renderDropdownItem = () => {
    const target_item = workgroupSettingInfo.item;
    const valid_menus = [
      {
        resource: t("meeting.action.start"),
        key: "startMeeting",
        icon: <Icons variant="line" label="play" />,
        onClick: () => startZoomMeeting(target_item),
      },
      {
        resource: t("meeting.action.join"),
        key: "enterMeeting",
        icon: <Icons variant="line" label="zoom" />,
        onClick: () => startZoomMeeting(target_item),
      },
      {
        resource: t("common.edit"),
        key: "editMeeting",
        icon: <Icons variant="line" label="edit2" />,
        onClick: () => {
          if (!appState.appRegisterStatus.zoom)
            changeOpenExtraModal(
              `REGISTER_ZOOM@@${target_item.meetingId}/${target_item.occurrenceId}`
            );
          else handleChooseEditMeetingStatus(target_item);
        },
      },
      {
        resource: t("meeting.action.invite"),
        key: "linkMeeting",
        icon: <Icons variant="line" label="link" />,
        onClick: () => {
          changeMeetingOpenModal(target_item);
          changeOpenExtraModal("SHARE_LINK");
        },
      },
      {
        resource: t("file.action.preview"),
        key: "preview",
        icon: <Icons variant="line" label="preview" isOn />,
        onClick: () =>
          target_item &&
          utilsCommon.checkLicenseAvailable("allowWebView") &&
          utilsCommon.checkExtensionAvailable(
            target_item.contentName,
            "fwocExtensions"
          ) &&
          handleDocPreview({
            permission: "view",
            workgroupId: target_item?.workgroupId,
            syncId: target_item?.syncId,
            toast,
            t,
            revisionNo: 0,
            tab: "alarmType" in target_item ? "comment" : undefined,
          }),
      },
      {
        resource: t("file.action.download"),
        key: "download",
        icon: <Icons variant="line" label="download" />,
        onClick: () =>
          handleDocDownload(
            target_item?.syncId ?? "",
            getContentDownload,
            toast,
            t
          ),
      },
    ];
    const validMenu = valid_menus.filter((item) =>
      utilsCommon.checkMenuAvailble(item.key, target_item)
    );
    return (
      <DropdownBody
        dropdownRef={inputRef}
        width={190}
        location={{
          x: workgroupSettingInfo.x - 190,
          y:
            workgroupSettingInfo.y -
            (workgroupSettingInfo.y > window.innerHeight / 2 ? size.height : 0),
        }}
      >
        {validMenu?.map((item) => (
          <DropdownItem
            height={20}
            label={item.resource}
            frontIcon={item.icon}
            onClick={item.onClick}
          />
        ))}
      </DropdownBody>
    );
  };
  const handleGetMeetingDetail = async (
    meetingId: string,
    occurrenceId?: string
  ) => {
    let resp: any = await getMeetingDetail({
      workgroupId,
      meetingId: meetingId,
      occurrenceId: occurrenceId ?? "NONE",
    });
    if (resp.payload) {
      changeMeetingOpenModal(resp.payload.meetingBasicInfo);
    } else {
      toast.toastMsg(nanoid(), t("log.deleteMeeting"), "error");
    }
  };
  return (
    <Box width={"100%"} classes={"workgroupHome"} id="workgroupHome">
      {openExtraModal !== "SHARE_LINK" && openMeetingModal && (
        <MeetingDetailModal
          open={!!openMeetingModal}
          meetingInfo={openMeetingModal}
          onClose={() => changeMeetingOpenModal(undefined)}
        />
      )}
      {openExtraModal.startsWith("REGISTER_ZOOM") && (
        <AppRegisterModal
          open
          onClose={() => changeOpenExtraModal("CLOSE")}
          openLinkAppModal="open_zoom"
          modalType={"CONNECT"}
          handleAfter={() => {
            const meetingSimpleInfo = openExtraModal
              .split("REGISTER_ZOOM@@")[1]
              .split("/");
            openExtraModal.includes("@@")
              ? handleChooseEditMeetingStatus({
                  meetingId: meetingSimpleInfo[0],
                  occurrenceId: meetingSimpleInfo[1],
                })
              : navigate(
                  `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting?subTab=CREATE`
                );
          }}
        />
      )}
      {openExtraModal === "SHARE_LINK" && (
        <ShareMeetingLinkModal
          open
          onClose={() => {
            handleInitSettingInfo();
            changeMeetingOpenModal(undefined);
            changeOpenExtraModal("CLOSE");
          }}
          meetingInfo={
            workgroupState.calendarCount.filter(
              (item: CalendarCount) =>
                dayjs(parseInt(item.date)).format("YYYY-MM-DD") ===
                dayjs(selected).format("YYYY-MM-DD")
            )[workgroupSettingInfo.id]?.meetingInfo ?? openMeetingModal
          }
        />
      )}
      {openExtraModal.includes("CHANGE_MEETING@@") && (
        <Modal
          open
          onClose={() => {
            changeOpenExtraModal("CLOSE");
            handleInitSettingInfo();
          }}
          title={t("meeting.edit")}
          width={540}
          bodyMsg={t("meeting.recurring.edit")}
          footer={
            <Box>
              <Button
                label={t("meeting.recurring.editOnlyOne")}
                btnStyle="fill"
                type="secondary"
                onClick={() => {
                  changeOpenExtraModal("CLOSE");
                  handleInitSettingInfo();
                  sessionStorage.setItem(
                    "changeMeeting",
                    openExtraModal.split("CHANGE_MEETING@@")[1]
                  );
                  navigate(
                    `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting?subTab=CHANGE`
                  );
                }}
              />
              <Button
                label={t("meeting.recurring.editAll")}
                btnStyle="fill"
                onClick={() => {
                  sessionStorage.setItem(
                    "changeMeeting",
                    openExtraModal.split("CHANGE_MEETING@@")[1].split("/")[0] +
                      "/ALL"
                  );
                  changeOpenExtraModal("CLOSE");
                  handleInitSettingInfo();
                  navigate(
                    `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting?subTab=CHANGE`
                  );
                }}
              />
            </Box>
          }
        />
      )}
      {workgroupSettingInfo.id !== -1 && renderDropdownItem()}
      {["CREATE_NEW_WORKGROUP", "SEND_FILE"].includes(openExtraModal) && (
        <WorkgroupAddModal
          createType={
            openExtraModal === "CREATE_NEW_WORKGROUP"
              ? "CREATE_NEW_WORKGROUP"
              : "SEND_FILE"
          }
          open
          onClose={() => changeOpenExtraModal("CLOSE")}
        />
      )}
      {["SHARE_TO_WORKGROUP"].includes(openExtraModal) && (
        <FileUploadModal
          open
          onClose={() => changeOpenExtraModal("CLOSE")}
          workgroupId={workgroupId}
        />
      )}
      <Box direction="column" width={"100%"}>
        <Box width={"100%"} alignItems="center">
          {utilsCommon.checkUploadFilePermission(loginDto) && (
            <Button
              label={t("file.action.upload")}
              btnStyle="line"
              classes="home-startButton  mg mr-16"
              leadingIcon={
                <Box classes="home-icon">
                  <Icons
                    variant="line"
                    label="upload"
                    size={20}
                    stroke={getColor("COLOR_ICON_BRAND")}
                  />
                </Box>
              }
              onClick={() => changeOpenExtraModal("SHARE_TO_WORKGROUP")}
            />
          )}
          {utilsCommon.checkMenuAvailable("zoom") !== false && (
            <Button
              label={t("workgroup.home.createMeeting")}
              btnStyle="line"
              classes="home-startButton"
              leadingIcon={
                <Box classes="home-icon">
                  <Icons
                    variant="line"
                    label="zoomIn"
                    size={20}
                    stroke={getColor("COLOR_ICON_BRAND")}
                  />
                </Box>
              }
              onClick={() =>
                !!appState.appRegisterStatus.zoom
                  ? navigate(
                      `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting?subTab=CREATE`
                    )
                  : changeOpenExtraModal("REGISTER_ZOOM")
              }
            />
          )}
          <Box width={"23%"} classes="mg ml-auto">
            <Box>
              <Typography type="subtitle1">{t("common.member")}</Typography>
              <Typography
                type="subtitle1"
                exactColor={getColor("COLOR_TEXT_INFO")}
                classes="mg ml-4"
              >
                {workgroupState.workgroupDetail?.workgroup?.members.length}
              </Typography>
            </Box>
            <Box
              classes="mg ml-auto cursor pointer"
              onClick={() => toggleOpenMemberTab(!openMemberTab)}
            >
              <Icons
                variant="fill"
                label="chevron"
                direction={openMemberTab ? "right" : "down"}
              />
            </Box>
          </Box>
        </Box>
        <Box height={"calc(100% - 40px)"}>
          <Box
            direction="column"
            width={openMemberTab ? "calc(77% - 20px)" : "100%"}
          >
            <Box direction="column">
              <Typography type="subtitle1" classes="mg mt-24">
                My Tasks
              </Typography>
              <Box classes="mg mt-12 workgroupHome-myTasks">
                <Box
                  direction="column"
                  width={"100%"}
                  classes="cursor pointer"
                  onClick={() =>
                    navigate(
                      `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/file?readRequestFilter=true`
                    )
                  }
                >
                  <Box>
                    <Box classes="workgroupHome-myTasks--icon">
                      <Icons
                        variant={"line"}
                        label={"octagon"}
                        stroke="white"
                        size="25px"
                      />
                    </Box>
                    <Typography type="h1" classes="mg ml-auto">
                      {dashboard?.readRequestCount ?? 0}
                    </Typography>
                  </Box>
                  <Typography type="subtitle2" classes="mg mt-8">
                    {t("home.myTasks.readRequst")}
                  </Typography>
                </Box>
                <Box
                  direction="column"
                  width={"100%"}
                  classes="cursor pointer"
                  onClick={() =>
                    utilsCommon.getChatAvailibility() === "true"
                      ? navigate(
                          `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/chat`
                        )
                      : navigate(
                          `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/file?period=1day`
                        )
                  }
                >
                  <Box>
                    <Box classes="workgroupHome-myTasks--icon">
                      <Icons
                        variant={"line"}
                        label={"chat"}
                        stroke="white"
                        size="25px"
                      />
                    </Box>
                    <Typography type="h1" classes="mg ml-auto">
                      {utilsCommon.getChatAvailibility() === "true"
                        ? dashboard?.unreadChat ?? 0
                        : dashboard?.todayUpdateFileCount}
                    </Typography>
                  </Box>
                  <Typography type="subtitle2" classes="mg mt-8">
                    {utilsCommon.getChatAvailibility() === "true"
                      ? t("common.chat")
                      : t("workgroup.home.todayUpdateFile")}
                  </Typography>
                </Box>
                {utilsCommon.checkMenuAvailable("zoom") !== false && (
                  <Box
                    direction="column"
                    width={"100%"}
                    classes="cursor pointer"
                    onClick={() =>
                      navigate(
                        `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/meeting`
                      )
                    }
                  >
                    <Box>
                      <Box classes="workgroupHome-myTasks--icon">
                        <Icons
                          variant={"line"}
                          label={"video"}
                          stroke="white"
                          size="25px"
                        />
                      </Box>
                      <Typography type="h1" classes="mg ml-auto">
                        {dashboard?.todayMeeringCount ?? 0}
                      </Typography>
                    </Box>
                    <Typography type="subtitle2" classes="mg mt-8">
                      {t("home.myTasks.todayMeeting")}
                    </Typography>
                  </Box>
                )}
              </Box>
            </Box>
            <Box direction="column">
              <Typography type="subtitle1" classes="mg mt-24">
                {t("workgroup.home.calendar")}
              </Typography>
              <Box classes="workgroupHome-calendar">
                {renderWorkgroupCalendar()}
                {renderWorkgroupSelectList()}
              </Box>
            </Box>
            <Box direction="column">
              <Typography type="subtitle1" classes="mg mt-24">
                {t("common.log")}
              </Typography>
              <Box classes="workgroupHome-log">
                {logState.summaryLogList?.length > 0 && (
                  <Box minHeight={12} classes="workgroupHome-log--buffer" />
                )}
                <CompressWorkgroupLog
                  workgroupId={workgroupId}
                  changeDocAsideIndex={() =>
                    navigate(
                      `${process.env.PUBLIC_URL}/workgroup/${workgroupId}/log`
                    )
                  }
                  pageType="workgroupHome"
                  settingButtonInfo={settingButtonInfo}
                  setSettingInfo={setSettingInfo}
                  handleGetMeetingDetail={handleGetMeetingDetail}
                />
              </Box>
              {settingButtonInfo.logId && (
                <LogSettingButton
                  settingButtonInfo={settingButtonInfo}
                  setSettingInfo={setSettingInfo}
                />
              )}
            </Box>
          </Box>
          {openMemberTab && renderMemberTab()}
        </Box>
      </Box>
    </Box>
  );
};

export default WorkgroupHome;
